
<div id="header-top" class="primary-background primary-font-color">
  <div class=" wrapper wrap">
    <div class="row">
      <div class="col-md-12">
      </div>
    </div>
    <div class="row title-search-container">
      <div class="col-md-8">
        <div class="site-logo">
          <a class="logo custom-logo header-logo" href="https://www.dorsetcouncil.gov.uk"
            title="Go to Dorset Council">
            <img alt="Dorset Council" style="max-height: 80px; margin: 20px;"
              src="https://www.dorsetcouncil.gov.uk/image/layout_set_logo?img_id=3219019&amp;t=1749740840898">
          </a>
        </div>
        <!-- <div class="d-md-none">
          <div class="account-links" role="region" aria-label="account">
            <a href="/sign-in-to-a-service">Your account</a>
          </div>
        </div> -->
      </div>
      <!-- <div class="col-md-4">
        <div
          class="portlet-boundary portlet-boundary_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_  portlet-static portlet-static-end portlet-barebone portlet-search-bar "
          id="p_p_id_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_">
          <span
            id="p_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch"></span>
          <section class="portlet"
            id="portlet_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch">
            <div class="portlet-content">
              <div class=" portlet-content-container">
                <div class="portlet-body">
                  <form action="https://www.dorsetcouncil.gov.uk/search" class="form  "
                    data-fm-namespace="_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_"
                    id="_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_fm"
                    method="get"
                    name="_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_fm"
                    data-dashlane-rid="8c70cab10f95da45">
                    <input class="field form-control"
                      id="_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_formDate"
                      name="_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_formDate"
                      type="hidden" value="1750061462208">
                    <div class="search-bar">
                      <input class="field search-bar-empty-search-input form-control"
                        id="_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_emptySearchEnabled"
                        name="_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_emptySearchEnabled"
                        type="hidden" value="false">
                      <div class="input-group search-bar-simple">
                        <div class="input-group-item search-bar-keywords-input-wrapper">
                          <input aria-label="Search"
                            class="form-control input-group-inset input-group-inset-after search-bar-keywords-input"
                            data-qa-id="searchInput" id="dkrk___q" name="q" placeholder="Search..." title="Search"
                            type="text" value="" data-dashlane-rid="fb3ed3d44f45ac2d">
                          <input class="field form-control"
                            id="_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_scope"
                            name="_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_scope"
                            type="hidden" value="">
                          <div class="input-group-inset-item input-group-inset-item-after">
                            <button class="btn btn-monospaced btn-unstyled" type="submit" aria-label="Search"
                              data-dashlane-label="true" data-dashlane-rid="a41f0321e970c1bd"><span
                                class="inline-item"><svg class="lexicon-icon lexicon-icon-search" role="presentation"
                                  viewBox="0 0 512 512">
                                  <g>
                                    <path class="lexicon-icon-outline"
                                      d="M499.2,455.5L377.7,333.4c146-241.1-148.1-435.8-318.2-274c-165.1,185.9,41.6,460.6,273.4,319l121.5,118.8C489.5,535.8,534.4,490.8,499.2,455.5z M206.2,63.6c191.9,0,198.1,289,0,289C13.3,352.6,18.8,63.6,206.2,63.6z">
                                    </path>
                                  </g>
                                </svg></span></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  <script>
                    AUI().use(
                      'liferay-form',
                      function (A) {
                        (function () {
                          var $ = AUI.$; var _ = AUI._;
                          Liferay.Form.register(
                            {
                              id: '_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_fm'
                              , fieldRules: [
                              ]
                              , validateOnBlur: true
                            }
                          );
                          var onDestroyPortlet = function (event) {
                            if (event.portletId === 'com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch') {
                              delete Liferay.Form._INSTANCES['_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_fm'];
                            }
                          };
                          Liferay.on('destroyPortlet', onDestroyPortlet);
                          Liferay.fire(
                            '_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_formReady',
                            {
                              formName: '_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_fm'
                            }
                          );
                        })();
                      });
                  </script>
                  <script>
                    AUI().use(
                      'liferay-search-bar',
                      'aui-base',
                      function (A) {
                        (function () {
                          var $ = AUI.$; var _ = AUI._;
                          if (!A.one('#_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_reactSearchBar')) {
                            new Liferay.Search.SearchBar(A.one('#_com_liferay_portal_search_web_search_bar_portlet_SearchBarPortlet_INSTANCE_templateSearch_fm'));
                          }

                        })();
                      });
                  </script>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div> -->
    </div>
  </div>
</div>

<!-- <div class="wrapper wrap" *ngIf="displayBanner">
  <div class="govuk-phase-banner">
    <p class="govuk-phase-banner__content">
      <strong class="govuk-tag govuk-phase-banner__content__tag">
        Beta
      </strong>
      <span class="govuk-phase-banner__text">
        <span [innerHTML]="bannerText"></span>
      </span>
    </p>
  </div>
</div> -->
